import React from 'react';
import PropTypes from 'prop-types';

import { getUserId } from '../../../utils/functions';

import { ButtonBlueLarge } from '../../Buttons/ButtonBlueLarge/ButtonBlueLarge';
import ButtonBlueOutlineLarge from '../../Buttons/ButtonBlueOutlineLarge/ButtonBlueOutlineLarge';
import ButtonRedOutlineLarge from '../../Buttons/ButtonRedOutlineLarge/ButtonRedOutlineLarge';
import TitleDialog from '../../TitleDialog/TitleDialog';
import Textarea from '../../Textarea/Textarea';

import {
    DIALOG_CONFIRMATION_TICKET_CANCEL_BUTTON,
    DIALOG_CONFIRMATION_TICKET_CONTENT,
    DIALOG_CONFIRMATION_TICKET_CONTENT_FAST_ANSWER,
    DIALOG_CONFIRMATION_TICKET_OK_BUTTON,
    DIALOG_CONFIRMATION_TICKET_OK_BUTTON_FAST_ANSWER,
    DIALOG_CONFIRMATION_TICKET_TITLE,
    DIALOG_CONFIRMATION_TICKET_TITLE_FAST_ANSWER,
} from './translations'

import styles from './DialogConfirmationTicket.module.css';

export default class DialogConfirmationTicket extends React.PureComponent {
    static propTypes = {
        id: PropTypes.number.isRequired,
        isFastAnswer: PropTypes.bool,

        type: PropTypes.string,

        onCloseDialog: PropTypes.func.isRequired,
        onSubmitDialog: PropTypes.func.isRequired,
        onFastAnswer: PropTypes.func,
    }

    constructor(props) {
        super(props)
    
        this.state = {
          content: '',
          isErrorText: false,
        }
      }

    handleSubmitDialog = () => {
        this.props.isFastAnswer ? 
            this.props.onFastAnswer( this.props.id, this.state.content, getUserId(), this.props.type ) 
                : this.props.onSubmitDialog( this.props.id )
    }

    handleDescriptionChange = (content) => {
        this.setState({
            content,
            isErrorText: false,
        })
    }

    render() {
        return !this.props.isFastAnswer ? (
            <div className={styles.base}>
                <TitleDialog>{DIALOG_CONFIRMATION_TICKET_TITLE}</TitleDialog>
                <div className={styles.content}>
                    <p>{DIALOG_CONFIRMATION_TICKET_CONTENT}</p>
                </div>
                <div className={styles.button}>
                    <ButtonBlueLarge onClick={this.props.onCloseDialog}>
                        {DIALOG_CONFIRMATION_TICKET_CANCEL_BUTTON}
                    </ButtonBlueLarge>
                </div>
                <div className={styles.button}>
                    <ButtonRedOutlineLarge onClick={this.handleSubmitDialog}>
                        {DIALOG_CONFIRMATION_TICKET_OK_BUTTON}
                    </ButtonRedOutlineLarge>
                </div>
            </div>
        ) : (
            <div className={styles.base}>
                <TitleDialog>{DIALOG_CONFIRMATION_TICKET_TITLE_FAST_ANSWER}</TitleDialog>
                <div className={styles.content}>
                    <p>{DIALOG_CONFIRMATION_TICKET_CONTENT_FAST_ANSWER}</p>
                    <Textarea 
                        isError={this.state.isErrorText}
                        value={this.state.content}
                        onChange={this.handleDescriptionChange} 
                    />
                </div>
                <div className={styles.button}>
                    <ButtonBlueLarge onClick={this.props.onCloseDialog}>
                        {DIALOG_CONFIRMATION_TICKET_CANCEL_BUTTON}
                    </ButtonBlueLarge>
                </div>
                <div className={styles.button}>
                    <ButtonBlueOutlineLarge onClick={this.handleSubmitDialog}>
                        {DIALOG_CONFIRMATION_TICKET_OK_BUTTON_FAST_ANSWER}
                    </ButtonBlueOutlineLarge>
                </div>
            </div>
        )
    }
}
